export default __webpack_public_path__ + "static/media/egypt.28bafecc.jpg";